import { FC } from 'react';
import { Link } from 'react-router-dom';

const NotFound: FC = () => {
    return (
        <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
            <h1 className="text-gray-800 text-9xl font-bold">404</h1>
            <p className="text-gray-600 mb-8 text-2xl font-medium">
                Page non trouvée
            </p>
            <p className="text-gray-500 mb-8">
                La page que vous recherchez n'existe pas ou a été déplacée.
            </p>
            <Link
                to="/"
                className="bg-blue-600 hover:bg-blue-700 rounded-md px-6 py-3 font-medium text-white transition-colors"
            >
                Retour à l'accueil
            </Link>
        </div>
    );
};

export default NotFound;
